import React from 'react';
import { hot } from 'react-hot-loader';
import classnames from 'classnames';
import Button from 'react-bootstrap/Button';

import styles from './styles.module.css'

const BaseButton = ({ className, variant, onClick, children, disabled = false }) => {
  return (
    <Button className={classnames(className, styles.base_button)} variant={variant} onClick={onClick} disabled={disabled}>
      {children}
    </Button>
  );
};

export default hot(module)(BaseButton);
